
import { showSnackbar } from 'utils/snack_bar/store/action';
import { CREATE_SEASON, DELETE_SEASON, UPDATE_SEASON } from '../graphql/mutation';
import { FETCH_SEASON_BY_SERIES_ID } from '../graphql/query';
import { actionTypes, UpdateSeasonInput, VideoSeasonInput, VideoSeasonProps } from './actionType';
import { executeMutation, executeQuery } from 'utils/services/apiServices';

export const fetchVideoSeasonRequest = () => ({
    type: actionTypes.FETCH_VIDEO_SEASON_REQUEST
});

export const fetchVideoSeasonSuccess = (payload: VideoSeasonProps[]) => ({
    type: actionTypes.FETCH_VIDEO_SEASON_SUCCESS,
    payload
});

export const fetchVideoSeasonFail = (payload: string) => ({
    type: actionTypes.FETCH_VIDEO_SEASON_FAIL,
    payload
});

export const fetchVideoSeason = (series_id:string) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchVideoSeasonRequest());
            const input = {
                series_id: series_id
            };
            const response = await executeQuery(FETCH_SEASON_BY_SERIES_ID,input);
            const jsonData = response.data?.fetchSeasonBySeriesId;
            if (jsonData?.error === null) {
                dispatch(fetchVideoSeasonSuccess(jsonData?.data.seasons));
            } else {
                dispatch(fetchVideoSeasonFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchVideoSeasonFail('Failed to fetch VideoSeason'));
        }
    };
};

//Create season
export const createVideoSeasonSuccess= (payload: VideoSeasonProps) => ({
    type: actionTypes.CREATE_VIDEO_SEASON_SUCCESS,
    payload
});
export const createVideoSeasonFail= (payload: string) => ({
    type: actionTypes.CREATE_VIDEO_SEASON_FAIL,
    payload
});
export const createVideoSeason = (input: VideoSeasonInput) => {
    return async (dispatch: any) => {
        try {
            const inputData ={
                input: input
            }
            const response = await executeMutation(CREATE_SEASON, inputData);
            const jsonData = response.data?.createSeason;
            if (jsonData?.error === null) {
                dispatch(createVideoSeasonSuccess(jsonData?.data.video_season));
                 dispatch(showSnackbar('Success! season created.'));
            } else {
                dispatch(createVideoSeasonFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(createVideoSeasonFail('Something went wrong, Try again later'))
        }
    };
};

//Update season
export const updateVideoSeasonSuccess= (payload: VideoSeasonProps) => ({
    type: actionTypes.UPDATE_VIDEO_SEASON_SUCCESS,
    payload
});
export const updateVideoSeasonFail= (payload: string) => ({
    type: actionTypes.UPDATE_VIDEO_SEASON_FAIL,
    payload
});
export const updateVideoSeason = (input: UpdateSeasonInput) => {
    return async (dispatch: any) => {
        try {
            const inputData ={
                input: input
            }
            const response = await executeMutation(UPDATE_SEASON, inputData);
            const jsonData = response.data?.updateSeason;
            if (jsonData?.error === null) {
                dispatch(updateVideoSeasonSuccess(jsonData?.data.video_season));
                 dispatch(showSnackbar('Success! season updated.'));
            } else {
                dispatch(updateVideoSeasonFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(updateVideoSeasonFail('Something went wrong, Try again later'))
        }
    };
};


//Update season
export const deleteVideoSeasonSuccess= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_SEASON_SUCCESS,
    payload
});
export const deleteVideoSeasonFail= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_SEASON_FAIL,
    payload
});
export const deleteVideoSeason = (folder_id: string, season_id: string) => {
    return async (dispatch: any) => {
        try {
            const inputData ={
                season_id: season_id, folder_id: folder_id
            }
            const response = await executeMutation(DELETE_SEASON, inputData);
            const jsonData = response.data?.deleteSeason;
            if (jsonData?.error === null) {
                dispatch(deleteVideoSeasonSuccess(season_id));
                 dispatch(showSnackbar('Success! season deleted.'));
            } else {
                dispatch(deleteVideoSeasonFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(deleteVideoSeasonFail('Something went wrong, Try again later'))
        }
    };
};



